<template>

    <!-- it-offcanvus-area-start -->
    <div class="it-offcanvas-area">
        <div class="itoffcanvas">
            <div class="it-offcanva-bottom-shape d-none d-xxl-block">
            </div>
            <div class="itoffcanvas__close-btn">
                <button class="close-btn"><i class="fal fa-times"></i></button>
            </div>
            <div class="itoffcanvas__logo">
                <a href="#">
                    <img src="/img/logo/logo-blue.png" alt="">
                </a>
            </div>
            <div class="it-menu-mobile"></div>
        </div>
    </div>
    <div class="body-overlay"></div>
    <!-- it-offcanvus-area-end -->

    <header class="it-header-height">

        <!-- header-top-area-start -->
        <div class="it-header-2-top-area it-header-2-top-style black-bg">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-8 col-lg-6 col-md-5 col-sm-7">
                        <div class="it-header-2-top-left">
                            <ul>
                                <li class="d-none d-xl-inline-block">
                                    <a href="tel:(91)9619392909">
                                        <span>
                                            <i class="fa-light fa-phone-volume"></i>
                                        </span>
                                        9619392909/9619392909
                                    </a>
                                </li>
                                <li class="d-none d-xl-inline-block">
                                    <a href="mailto:achieversaime2025@gmail.com">
                                        <span>
                                            <i class="fa-light fa-envelope-open-text"></i>
                                        </span>achieversaime2025@gmail.com
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-7 col-sm-5 d-none d-sm-block">
                        <div class="it-header-2-top-right-wrap text-end">
                            <div class="it-header-2-top-right">
                                <ul>
                                    <li>
                                        <div class="it-header-2-top-social">
                                            <a href="#"><i class="fab fa-facebook-f"></i></a>
                                            <a href="#"><i class="fab fa-twitter"></i></a>
                                            <a href="#"><i class="fab fa-skype"></i></a>
                                            <a href="#"><i class="fab fa-linkedin"></i></a>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- header-top-area-end -->

        <!-- header-area-end -->
        <div id="header-sticky" class="it-header-5-area it-header-1-style it-header-2-style" style="display: none;">
            <div class="container">
                <div class="it-header-wrap p-relative">
                    <div class="row align-items-center">
                        <div class="col-xl-3 col-6">
                            <div class="it-header-5-logo">
                                <router-link to="/"><img src="/img/logo/logo-blue.png" alt=""
                                        style="width: 100%;"></router-link>
                            </div>
                        </div>
                        <div class="col-xl-12 d-none d-xl-block">
                            <div class="it-header-2-main-menu">
                                <nav class="it-menu-content">
                                    <ul>
                                        <li><router-link to="/">Home</router-link></li>
                                        <li class="has-dropdown">
                                            <a href="">About Us</a>
                                            <ul class="it-submenu submenu">
                                                <li><router-link to="/aboutcollege">About College</router-link></li>
                                                <li><router-link to="/directorMessage">Director Message</router-link>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="has-dropdown">
                                            <a href="">Academics</a>
                                            <ul class="it-submenu submenu">
                                                <li><router-link to="/courses">Courses</router-link></li>
                                                <li><router-link to="/eligiblity">Eligiblity</router-link></li>
                                            </ul>
                                        </li>
                                        <li class="has-dropdown">
                                            <a href="">Achievers Edge</a>
                                            <ul class="it-submenu submenu">
                                                <li><router-link to="/achievers">Why Achievers?</router-link></li>
                                                <li><router-link to="/infra">Infrastructure</router-link></li>
                                            </ul>
                                        </li>
                                        <li><router-link to="/admission">Admission</router-link></li>
                                        <li><router-link to="/contact">Contact</router-link></li>

                                    </ul>
                                </nav>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="header-wrapper">
            <Menubar :model="items" class="custom-menubar">
                <template #start>
                    <router-link to="/" class="logo-link">
                        <img src="/img/logo/logo-blue.png" alt="Logo" height="120" />
                    </router-link>
                </template>

                <template #end>
                    <Button label="Contact" icon="pi pi-envelope" class="p-button-outlined p-button-sm"
                        @click="goToContact" />
                </template>
            </Menubar>
        </div>


    </header>
</template>
<script>
import Menubar from "primevue/menubar";

export default {
    name: "AppHeader",
    components: {
        Menubar
    },
    data() {
        return {
            items: [
                {
                    label: "Home",
                    icon: "pi pi-home",
                    command: () => this.$router.push("/"),
                },
                {
                    label: "About us",
                    items: [
                        {
                            label: "About College",
                            command: () => this.$router.push("/aboutcollege"),
                        },
                        {
                            label: "Director Message",
                            command: () => this.$router.push("/directormessage"),
                        },
                        {
                            label: "Mentor Board",
                            command: () => this.$router.push("/mentorboard"),
                        },
                    ],
                },
                {
                    label: "Academics",
                    items: [
                        {
                            label: "Courses",
                            command: () => this.$router.push("/courses"),
                        },
                        {
                            label: "Eligibility",
                            command: () => this.$router.push("/eligiblity"),
                        },
                    ],
                },
                {
                    label: "Achievers Edge",
                    items: [
                        {
                            label: "Why Achievers",
                            command: () => this.$router.push("/achievers"),
                        },
                        {
                            label: "Infrastructure",
                            command: () => this.$router.push("/infra"),
                        },
                    ],
                },
                {
                    label: "Admission",
                    command: () => this.$router.push("/admission"),
                },
                {
                    label: "Contact",
                    command: () => this.$router.push("/contact"),
                },
            ],
        };
    },

    methods: {
        goToContact() {
            this.$router.push("/contact");
        },
    },
};
</script>

<style scoped>
.header-wrapper {
    position: relative;
    z-index: 9999;
}

/* ✅ Center the Menubar items */
.custom-menubar {
    justify-content: center;
    /* centers items horizontally */
}

/* Make sure logo and button stay fixed on sides if you want */
:deep(.p-menubar-start) {
    margin-right: auto;
    /* pushes items to center */
}

:deep(.p-menubar-end) {
    margin-left: auto;
    /* pushes right content to edge */
}

/* Optional: styling tweaks */
.logo-link img {
    display: block;
    max-height: 80px;
    margin-left: 1rem;
}
</style>